import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

class BookingButtonPresenterSessionTimeout extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    
    var tabClasses = clsx({
			'active': this.props.active_tab == 'session_timeout',
			'tab-pane': true,
    })
    
    return (
      <div className={tabClasses} id="session_timeout">
        <div className="form-group">
          <label>{I18n.t('status')} <span className="ss-help help" title={I18n.t('session_timeout_helper_text')}></span></label> 
          {this.props.session_timeout_enabled 
            ? <div>{I18n.t('enabled')}</div>
            : <div>{I18n.t('disabled')}</div>
          }
        </div>
        <div className="form-group">
          <label>{I18n.t('session_duration')} <span className="ss-help help" title={I18n.t('measured_in_seconds')}></span></label>
          <div>{this.props.session_timeout_duration}</div>
        </div>
        <div className="form-group">
          <label>{I18n.t('session_grace_period')} <span className="ss-help help" title={I18n.t('measured_in_seconds')}></span></label>
          <div>{this.props.session_grace_period}</div>
        </div>
        <div className="form-group">
          <label>{I18n.t('session_timeout_warning_text')} <span className="ss-help help" title={I18n.t('session_timeout_warning_text_helper_text')}></span></label>
          <div>{this.props.session_timeout_warning_text}</div>
        </div>
        <div className="form-group" style={{marginBottom: '0px'}}>
          <label>{I18n.t('session_timeout_confirmation_text')} <span className="ss-help help" title={I18n.t('session_timeout_confirmation_text_helper_text')}></span></label>
          <div>{this.props.session_timeout_confirmation_text}</div>
        </div>
      </div>
    )
  }
}

export default BookingButtonPresenterSessionTimeout